/* ==========================================================================
   ASCEND — catalog search bar (v9)

   Two behaviours, chosen by the form's data attribute:

     [data-cat-search-live]   collection page: filter the product cards already
                              on the page as you type. Matching ignores case,
                              spaces and punctuation and looks at the card's
                              title, type and tags (the same data-* the
                              filter/sort script reads). Enter keeps you on the
                              page. Cards are hidden with data-search-hide, a
                              DIFFERENT flag from the [hidden] the sort/filter
                              script owns, so the two never fight.

     (no attribute)           home page: plain submit to /search.

   ========================================================================== */
(function () {
  'use strict';
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }

  function initLive(form) {
    if (form.dataset.catBound === '1') return;
    form.dataset.catBound = '1';
    var input = form.querySelector('[data-cat-search]');
    var countEl = form.querySelector('[data-cat-search-count]');
    var root = document.querySelector('[data-collection-root]') || document;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-collection-card]'));
    var empty = root.querySelector('[data-search-empty]');
    var shownEl = root.querySelector('[data-collection-shown]');
    if (!input || !cards.length) return;

    var model = cards.map(function (el) {
      return { el: el, blob: norm(el.getAttribute('data-title') + ' ' + el.getAttribute('data-type') + ' ' + el.getAttribute('data-tags')) };
    });

    function apply() {
      var q = norm(input.value);
      var shown = 0;
      model.forEach(function (m) {
        var ok = !q || m.blob.indexOf(q) !== -1;
        if (ok) { m.el.removeAttribute('data-search-hide'); if (!m.el.hidden) shown++; }
        else { m.el.setAttribute('data-search-hide', ''); }
      });
      if (countEl) countEl.textContent = String(shown);
      if (shownEl) shownEl.textContent = String(shown);
      if (empty) empty.hidden = !(q && shown === 0);
    }

    var t;
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(apply, 40); });
    form.addEventListener('submit', function (e) { e.preventDefault(); apply(); input.blur(); });
    /* Deep link: /collections/all?q=bpc */
    try {
      var q = new URL(location.href).searchParams.get('q');
      if (q && !input.value) { input.value = q; }
    } catch (e) { /* ignore */ }
    apply();
  }

  function init() {
    document.querySelectorAll('[data-cat-search-form][data-cat-search-live]').forEach(initLive);
    document.querySelectorAll('[data-cat-search-form]:not([data-cat-search-live])').forEach(function (form) {
      var input = form.querySelector('[data-cat-search]');
      form.addEventListener('submit', function (e) { if (input && !input.value.trim()) { e.preventDefault(); input.focus(); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
